module.exports = __webpack_public_path__ + "static/media/login-2.0b30b51f.jpg";